import { addDoc, collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";
import { MARKDOWN_DOC_TYPE } from "schemas/documents";
import { editorActions } from "store/editor";

export async function createDocument(content, setProcessing, uid, dispatch) {
  try {
    setProcessing(true);
    const documentData = {
      uid,
      createdAt: new Date().getTime(),
      name: "New document",
      type: MARKDOWN_DOC_TYPE,
      content,
    };
    const documentRef = await addDoc(
      collection(
        db,
        COLLECTIONS.mdDocuments,
      ),
      documentData
    );
    const document = {
      id: documentRef.id,
      ...documentData,
    };
    dispatch(editorActions.setActiveDocument(document));
  } catch (error) {
    console.log(error);
  } finally {
    setProcessing(false);
  }
}